// import { useEffect, useState } from "react";
// import Layout1 from "../../assets/layout1.svg";
// import Layout2 from "../../assets/layout2.svg";
// import { AdPreview } from "./adPreview";
// import { Button } from "@/components/ui/button";
// import { cn } from "@/lib/utils";
// import Constants from "@/config/constants";
//
//
// const getAds = async () => {
//   const orgId = localStorage.getItem("orgId");
//   const response = await fetch(`${Constants.API_URL}/ads/${orgId}`, {
//     method: "GET",
//   });
//
//   if (!response.ok) throw new Error("Fetch failed");
//
//   return response.json();
// }
//
// export function LayoutSelectorForm() {
//   const [selectedLayout, setSelectedLayout] = useState<string | null>(null);
//   const [formData, setFormData] = useState({
//     image: null as File | null,
//     title: "",
//     description: "",
//   });
//
//   const [submitting, setSubmitting] = useState(false);
//   // State for modal/dialog
//   const layouts = [
//     { id: "layout1", title: "Layout 1", Icon: Layout1 },
//     { id: "layout2", title: "Layout 2", Icon: Layout2 },
//   ];
//
//   const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const file = e.target.files?.[0] ?? null; // default to null if no file
//     setFormData((prev) => ({ ...prev, image: file }));
//   };
//
//
//   const handleSubmit = async () => {
//     if (!selectedLayout) {
//       alert("Please select a layout first.");
//       return;
//     }
//     if (!formData.image) {
//       alert("Please upload an image.");
//       return;
//     }
//
//     // For layout2 we need extra validations
//     if (
//       selectedLayout === "layout2" &&
//       (!formData.title.trim() || !formData.description.trim())
//     ) {
//       alert("Please fill all fields for Layout 2.");
//       return;
//     }
//
//     try {
//       setSubmitting(true);
//
//       const data = new FormData();
//       data.append("image", formData.image!);
//       data.append("orgId", localStorage.getItem("orgId") ?? "");
//       if (selectedLayout === "layout2") {
//         data.append("title", formData.title);
//         data.append("description", formData.description);
//       }
//
//       // Example API request
//       const response = await fetch(`${Constants.API_URL}/ads`, {
//         method: "POST",
//         body: data,
//       });
//
//       if (!response.ok) throw new Error("Upload failed");
//
//       alert("Ad submitted successfully!");
//       setFormData({ image: null, title: "", description: "" });
//       setSelectedLayout(null);
//     } catch (err) {
//       console.error(err);
//       alert("Something went wrong!");
//     } finally {
//       setSubmitting(false);
//     }
//   };
//
//
//   const [ads, setAds] = useState<any[]>([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState<string | null>(null);
//
//   useEffect(() => {
//     let isMounted = true;
//     (async () => {
//       try {
//         setLoading(true);
//         const result = await getAds();
//         if (isMounted) setAds(result || []);
//       } catch (err: any) {
//         console.error(err);
//         if (isMounted) setError("Failed to load ads");
//       } finally {
//         if (isMounted) setLoading(false);
//       }
//     })();
//
//     return () => {
//       isMounted = false;
//     };
//   }, []);
//
//   const layout1Data = ads.find((ad: any) => ad.type === "image-only") || null;
//   const layout2Data = ads.find((ad: any) => ad.type === "combo") || null;
//
//
//   useEffect(() => {
//     if (selectedLayout === "layout1") {
//       setFormData({
//         image: layout1Data?.image,
//         title: layout1Data?.title,
//         description: layout1Data?.description,
//       });
//     }
//
//     if (selectedLayout === "layout2") {
//       setFormData({
//         image: layout2Data?.image,
//         title: layout2Data?.title,
//         description: layout2Data?.description,
//       });
//     }
//   }, [selectedLayout]);
//
//
//   if (loading) return <div className="text-gray-500 p-4">Loading ads...</div>;
//   if (error) return <div className="text-red-500 p-4">{error}</div>;
//
//   return (
//     <div className={cn("space-y-6 flex gap-4", selectedLayout ? "min-w-8xl" : "",)}>
//       <div className="space-y-6">
//         {/* Layout Selector */}
//         <div className="grid grid-cols-2 gap-6 min-w-md">
//           {layouts.map(({ id, title, Icon }) => (
//             <div
//               key={id}
//               onClick={() => setSelectedLayout(id)}
//               className={`border rounded-xl p-4 hover:shadow-lg transition cursor-pointer flex flex-col items-center ${selectedLayout === id ? "ring-2 ring-green-500" : ""
//                 }`}
//             >
//               <img src={Icon} className="h-40" alt={title} />
//               <p className="mt-2 text-lg font-medium">{title}</p>
//             </div>
//           ))}
//         </div>
//
//         {/* Dynamic Form Fields */}
//         {selectedLayout && (
//           <div className="mt-6 border rounded-xl p-4 space-y-4">
//             {/* Common Field (Image) */}
//             <div>
//               <label className="block text-sm font-medium mb-1">Image</label>
//               <input
//                 type="file"
//                 accept="image/*"
//                 className="block w-full border rounded-lg p-2"
//                 onChange={handleFileChange}
//               />
//             </div>
//
//             {/* Conditional Fields for Layout 2 */}
//             {selectedLayout === "layout2" && (
//               <>
//                 <div>
//                   <label className="block text-sm font-medium mb-1">Title</label>
//                   <input
//                     type="text"
//                     placeholder="Enter title"
//                     value={formData.title}
//                     onChange={(e) =>
//                       setFormData((prev) => ({ ...prev, title: e.target.value }))
//                     }
//                     className="block w-full border rounded-lg p-2"
//                   />
//                 </div>
//
//                 <div>
//                   <label className="block text-sm font-medium mb-1">
//                     Description
//                   </label>
//                   <textarea
//                     placeholder="Enter description"
//                     value={formData.description}
//                     onChange={(e) =>
//                       setFormData((prev) => ({
//                         ...prev,
//                         description: e.target.value,
//                       }))
//                     }
//                     className="block w-full border rounded-lg p-2"
//                     rows={3}
//                   />
//                 </div>
//               </>
//             )}
//             {/* Preview Dialog using shadcn */}
//
//             {/* Submit Button */}
//             <Button
//               onClick={handleSubmit}
//               disabled={submitting}
//               className={`mt-4 w-full py-2 rounded-lg text-white font-medium transition ${submitting
//                 ? "bg-gray-400 cursor-not-allowed"
//                 : "bg-green-600 hover:bg-green-700"
//                 }`}
//             >
//               {submitting ? "Submitting..." : "Submit"}
//             </Button>
//           </div>
//         )}
//       </div>
//       <AdPreview layout={selectedLayout} formData={formData} />
//     </div>
//   );
// }
//
import { useEffect, useState } from "react";
import Layout2 from "../../assets/layout1.svg";
import Layout1 from "../../assets/layout2.svg";
import { AdPreview } from "./adPreview";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import Constants from "@/config/constants";

const getAds = async () => {
  const orgId = localStorage.getItem("orgId");
  const response = await fetch(`${Constants.API_URL}/ads/${orgId}`, {
    method: "GET",
  });

  if (!response.ok) throw new Error("Fetch failed");

  return response.json();
};

export function LayoutSelectorForm() {
  const [selectedLayout, setSelectedLayout] = useState<string | null>("layout1");
  const [formData, setFormData] = useState({
    image: null as File | string | null,
    title: "",
    description: "",
  });

  const [submitting, setSubmitting] = useState(false);
  const [ads, setAds] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const layouts = [
    { id: "layout1", title: "Layout 1", Icon: Layout1 },
    { id: "layout2", title: "Layout 2", Icon: Layout2 },
  ];

  // 🔄 Fetch ads
  const fetchAds = async () => {
    try {
      setLoading(true);
      const result = await getAds();
      setAds(result || []);
    } catch (err) {
      console.error(err);
      setError("Failed to load ads");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAds();
  }, []);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] ?? null;
    setFormData((prev) => ({ ...prev, image: file }));
  };

  const handleSubmit = async () => {
    if (!selectedLayout) {
      alert("Please select a layout first.");
      return;
    }
    if (!formData.image) {
      alert("Please upload an image.");
      return;
    }

    if (
      selectedLayout === "layout1" &&
      (!formData.title.trim())
    ) {
      alert("Please fill all fields for Layout 1.");
      return;
    }

    try {
      setSubmitting(true);

      const data = new FormData();
      data.append("image", formData.image as File);
      data.append("orgId", localStorage.getItem("orgId") ?? "");
      if (selectedLayout === "layout1") {
        data.append("title", formData.title);
        data.append("description", formData.description === "" ? " " : formData.description);
      }

      const response = await fetch(`${Constants.API_URL}/ads`, {
        method: "POST",
        body: data,
      });

      if (!response.ok) throw new Error("Upload failed");

      alert("Ad submitted successfully!");
      setFormData({ image: null, title: "", description: "" });
      setSelectedLayout(null);

      // ✅ Refresh ads after submission
      await fetchAds();
    } catch (err) {
      console.error(err);
      alert("Something went wrong!");
    } finally {
      setSubmitting(false);
    }
  };

  const layout1Data = ads.find((ad: any) => ad.type === "combo") || null;
  const layout2Data = ads.find((ad: any) => ad.type === "image-only") || null;

  useEffect(() => {
    if (!layout1Data && !layout2Data) return;

    // Choose latest layout by updatedAt
    if (layout1Data?.updatedAt > layout2Data?.updatedAt) {
      setSelectedLayout("layout1");
    } else {
      setSelectedLayout("layout2");
    }
  }, [layout1Data, layout2Data]);

  useEffect(() => {
    setFormData({ image: null, title: "", description: "" });
    if (selectedLayout === "layout1" && layout1Data) {
      setFormData({
        image: layout1Data.image,
        title: layout1Data.title || "",
        description: layout1Data.description || "",
      });
    }

    if (selectedLayout === "layout2" && layout2Data) {
      setFormData({
        image: layout2Data.image,
        title: layout2Data.title || "",
        description: layout2Data.description || "",
      });
    }
  }, [selectedLayout, layout1Data, layout2Data]);

  if (loading) return <div className="text-gray-500 p-4">Loading ads...</div>;
  if (error) return <div className="text-red-500 p-4">{error}</div>;

  return (
    <div
      className={cn("space-y-6 flex gap-4", selectedLayout ? "min-w-8xl" : "")}
    >
      <div className="space-y-6">
        {/* Layout Selector */}
        <div className="grid grid-cols-2 gap-6 min-w-md">
          {layouts.map(({ id, title, Icon }) => (
            <div
              key={id}
              onClick={() => setSelectedLayout(id)}
              className={`border rounded-xl p-4 hover:shadow-lg transition cursor-pointer flex flex-col items-center ${selectedLayout === id ? "ring-2 ring-green-500" : ""
                }`}
            >
              <img src={Icon} className="h-40" alt={title} />
              <p className="mt-2 text-lg font-medium">{title}</p>
            </div>
          ))}
        </div>

        {/* Dynamic Form Fields */}
        {selectedLayout && (
          <div className="mt-6 border rounded-xl p-4 space-y-4">
            {/* Common Field (Image) */}
            <div>
              <label className="block text-sm font-medium mb-1">Image {
                selectedLayout == "layout2" ? "( 210px x 308px )" : " ( 240px x 84px )"

              }</label>
              <input
                type="file"
                accept="image/*"
                className="block w-full border rounded-lg p-2"
                onChange={handleFileChange}
              />
            </div>

            {/* Conditional Fields for Layout 2 */}
            {selectedLayout === "layout1" && (
              <>
                <div>
                  <label className="block text-sm font-medium mb-1">Title</label>
                  <input
                    type="text"
                    placeholder="Enter title"
                    value={formData.title}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        title: e.target.value,
                      }))
                    }
                    className="block w-full border rounded-lg p-2"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1">
                    Description
                  </label>
                  <textarea
                    placeholder="Enter description"
                    value={formData.description}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        description: e.target.value,
                      }))
                    }
                    className="block w-full border rounded-lg p-2"
                    rows={3}
                  />
                </div>
              </>
            )}

            {/* Submit Button */}
            <Button
              onClick={handleSubmit}
              disabled={submitting}
              className={`mt-4 w-full py-2 rounded-lg text-white font-medium transition ${submitting
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-green-600 hover:bg-green-700"
                }`}
            >
              {submitting ? "Submitting..." : "Submit"}
            </Button>
          </div>
        )}
      </div>

      {/* ✅ Always up-to-date preview */}
      <AdPreview layout={selectedLayout} formData={formData} />
    </div>
  );
}

